import { messages } from 'i18n';
import FormFieldOverlay from './FormFieldOverlay';

interface FormFieldSuggestionProps {
  text: string;
  onClick: () => void;
  tooltipText?: string;
  source?: string;
}

export default function FormFieldSuggestionOverlay({ text, onClick, tooltipText, source }: FormFieldSuggestionProps) {
  const labelText = source === 'web' ? messages.overlayChip.enrichedFromWeb : messages.overlayChip.suggested;
  return (
    <FormFieldOverlay
      text={text}
      onClick={onClick}
      bgColor="green.50"
      labelBgColor="green.50"
      labelText={labelText}
      labelTextColor="green.600"
      tooltipText={tooltipText}
      edge="end"
    />
  );
}
